import React, { ReactNode, useState } from "react";
import styles from '../LinkPersonalizado3/linkPersonalizado3.module.scss';

interface LinkPersonalizado3Props {
    href: string;
    title: string;
}

const LinkPersonalizado3: React.FC<LinkPersonalizado3Props> = ({
    href,
    title,
}) => {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="mb-4"
        >
            <div className={`${styles["h-32px"]} d-flex align-items-center justify-content-center`}>
                <div>
                    <span className={styles["title"]} style={{ letterSpacing: "2px", fontSize: "16px" }}><b>{title}</b></span>
                </div>
            </div>
        </a>
    );
};

export default LinkPersonalizado3;
